if (!customElements.get('accordion-item')) {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();
      this.isAnimating = false;
    }

    connectedCallback() {
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.accordion-body');
      this.iconVertical = this.querySelector('[data-icon-vertical]');

      if (!this.content || !this.summary) return;

      this.isOpen = this.dataset.startOpen === 'true';
      this.content.style.overflow = 'hidden';
      this.content.style.boxSizing = 'border-box';

      if (this.isOpen) {
        this.content.style.height = 'auto';
        this.content.style.opacity = '1';
      } else {
        this.content.style.height = '0';
        this.content.style.opacity = '0';
      }

      this.summary.setAttribute('aria-expanded', String(this.isOpen));
      this.updateIcon(this.isOpen);

      this.summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.isAnimating) this.toggle();
      });
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this.isAnimating = true;
      this.isOpen = true;
      this.summary.setAttribute('aria-expanded', 'true');
      this.updateIcon(true);

      const page = this.closest('faq-page');
      const scope = page || this.closest('[data-accordion-exclusive]');
      if (scope) {
        scope.querySelectorAll('accordion-item').forEach((sibling) => {
          if (sibling !== this && sibling.isOpen) sibling.close();
        });
      }

      const endHeight = this.content.scrollHeight;

      const animation = this.content.animate(
        [
          { height: '0px', opacity: 0 },
          { height: `${endHeight}px`, opacity: 1 }
        ],
        { duration: 300, easing: 'ease' }
      );

      animation.onfinish = () => {
        this.content.style.height = 'auto';
        this.content.style.opacity = '1';
        this.isAnimating = false;
      };
    }

    close() {
      this.isAnimating = true;
      this.isOpen = false;
      this.summary.setAttribute('aria-expanded', 'false');
      this.updateIcon(false);

      const startHeight = this.content.scrollHeight;

      const animation = this.content.animate(
        [
          { height: `${startHeight}px`, opacity: 1 },
          { height: '0px', opacity: 0 }
        ],
        { duration: 300, easing: 'ease' }
      );

      animation.onfinish = () => {
        this.content.style.height = '0';
        this.content.style.opacity = '0';
        this.isAnimating = false;
      };
    }

    updateIcon(isOpen) {
      if (this.iconVertical) {
        this.iconVertical.style.opacity = isOpen ? '0' : '1';
      }
    }
  }

  customElements.define('accordion-item', AccordionItem);
}
